<div class="post-screen-capture">
  @if (postLoading$ | async) {
    <app-loading></app-loading>
  }

  @if (screenCaptureUrl()) {
    <a
      class="capture"
      [href]="screenCaptureUrl()"
      target="_blank"
      rel="noopener"
      [suiTooltip]="'post-screen-capture.tooltip.open-full-size' | translate"
    >
      <img [src]="screenCaptureUrl()" appFallbackImage appLazyLoad alt="" />
    </a>
  }

  @if (!screenCaptureUrl() && !(postLoading$ | async)) {
    <div class="no-data">
      {{
        "post-screen-capture.message.no-screen-capture-available" | translate
      }}
    </div>
  }
</div>
